import { Component, computed, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { IncidentSeverityIconComponent } from '@incidents';
import { IncidentSeverity } from '@models';
import { SliderComponent } from '@ui';

@Component({
  imports: [ReactiveFormsModule, MatButtonToggleModule, IncidentSeverityIconComponent, SliderComponent],
  selector: 'avs-incident-rule-condition-fields',
  templateUrl: './incident-rule-condition-fields.component.html',
})
export class IncidentRuleConditionFieldsComponent {
  form = input.required<FormGroup>();
  durationMinutes = input.required<number>();

  protected eIncidentSeverity = IncidentSeverity;
  protected durationMinutesControl = computed(() => this.form().get('durationMinutes') as FormControl<number>);
  protected severityControl = computed(() => this.form().get('severity') as FormControl<IncidentSeverity>);
}
